import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { shiftRows } from '../data/content';
export function ShiftSection() {
  return <section className="w-full bg-cream py-14 sm:py-16 lg:py-20" aria-labelledby="paradigma" data-id="element-140" data-mp="c5g1fcbcq25c">
      <div className="mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-141" data-mp="3ujfled750rtd">
        <h2 id="paradigma" className="max-w-2xl font-display text-3xl font-extrabold leading-[1.1] tracking-tight text-ink sm:text-4xl lg:text-5xl" data-id="element-142" data-mp="2dk5o7wqmo4a">
          Ahorrar no debería significar vivir privándote.
        </h2>
        <p className="mt-4 max-w-2xl text-lg leading-relaxed text-ink-soft" data-id="element-143" data-mp="v1y2ikc3bee9">
          Esto no va de comprar siempre lo más barato, dejar de darte gustos ni convertir a tu
          familia en una planilla de cálculo. Va de comprar con estrategia lo que ya ibas a comprar.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-ink/10 bg-white shadow-card" data-id="element-144" data-mp="31rm56lr2w6c6">
          <div className="grid grid-cols-2" data-id="element-145" data-mp="36tv03nnihigx">
            <div className="border-b border-r border-ink/10 bg-cream-deep px-5 py-4" data-id="element-146" data-mp="vg2ocr1n0pb3">
              <p className="font-mono text-[11px] font-bold uppercase tracking-widest text-ink-muted" data-id="element-147" data-mp="qh9a2wej0u9v">
                Compra improvisada
              </p>
            </div>
            <div className="border-b border-ink/10 bg-verde px-5 py-4" data-id="element-148" data-mp="15ftmd2pepmfx">
              <p className="font-mono text-[11px] font-bold uppercase tracking-widest text-white" data-id="element-149" data-mp="10ee23cv1zjyl">
                Compra planificada
              </p>
            </div>
          </div>

          {shiftRows.map((row, i) => <div key={row.improvisada} className={`grid grid-cols-[1fr_auto_1fr] items-center gap-3 px-4 py-4 sm:gap-5 sm:px-5 ${i !== shiftRows.length - 1 ? 'border-b border-ink/10' : ''}`} data-id="element-150" data-mp="19fu00l4oltlx" data-mpi={i}>
              <p className="text-[15px] leading-snug text-ink-muted line-through decoration-ink/25" data-id="element-151" data-mp="1x6py1zzqdl1m">
                {row.improvisada}
              </p>
              <ArrowRightIcon className="h-4 w-4 shrink-0 text-verde" aria-hidden="true" data-id="element-152" data-mp="1t29sy0xxyhng" />
              <p className="text-[15px] font-semibold leading-snug text-ink" data-id="element-153" data-mp="2056nb7nm90sr">{row.planificada}</p>
            </div>)}
        </div>
      </div>
    </section>;
}